

import {
    Component,
    OnInit,
  } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { arrayUnion, updateDoc } from "firebase/firestore";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { environment } from "src/environments/environment";

  

@Component({
    selector: "app-carica-verbale_fase2-fase1",
    templateUrl: "./dialog-carica-verbale_fase2.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogCaricaVerbaleFase2 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected tipoDoc:String="";
    
    protected file: File;
    protected isUploadingDoc:boolean = false;
    
    protected label:string="Cerca verbale firmato ";
    protected icona:string="";
    protected stile:string="btn-choose-file-preventivo";
    protected fileClass:string="btn-choose-file-preventivo";
    protected acceptedFileTypes:string=".pdf";

    private collection_pratiche:string = environment.firebase.collection_pratiche;


    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      public firestore: AngularFirestore,
    ) {
      this.pratica          = this.config.data.pratica;
     
    }
  
    ngOnInit(): void {
    }

    onFileUpload($event){

    }

    onFileSelect($event: { files: File[]; }) {
      this.label = 'Verbale di ATTIVAZIONE caricato';
      
     
      this.icona = "pi pi-check";
      this.fileClass = "btn-preventivo-upload-success";
      this.file = $event.files[0];
      this.logger.info(this.file);
    }  

   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {

          this.logger.info(`[PRATICHE FASE 2] Aggiornamento della PRATICA ${this.pratica.cui}`);
          this.isUploadingDoc = true;
          let fileName = this.pratica.cui + "/IN/FASE_2/documentazione/" + this.pratica.cui +"_VERBALE_ATTIVAZIONE_FASE2.pdf";
          this.pratica.fileVerbaleAttivazioneUploaded = true;
          
         
          this.googleStorageService
          .uploadFileScuolaToGoogleStorage(this.file, fileName)
          .then((uploadRes) => {
            const docRef = this.firestore.collection(this.collection_pratiche).doc(this.pratica.cui);
           
            docRef.update(this.pratica)
              .then(() => {
                this.logger.info(`[PRATICHE FASE 2] PRATICA ${this.pratica.cui} aggiornatA con successo.`);
        
                this.isUploadingDoc = false;
                this.dialogRef.close({ success: true});
              })
              .catch((error) => {
                this.logger.error(`[PRATICHE FASE 2] Errore durante l'aggiornamento della PRATICA ${this.pratica.cui}:`, error);
                this.messageService.add({
                  severity: "info",
                  summary: "Errore" , life:10000,
                    detail: "Errore in fase di caricamento del documento "+this.tipoDoc+"!",
                  });
                
                this.dialogRef.close({ success: false });
              });
            
          })
          .catch((errore) => {
            this.messageService.add({
              severity: "info",
              summary: "Errore" , life:10000,
                detail: "Errore in fase di caricamento del documento "+this.tipoDoc+"!",
              });
            
            this.dialogRef.close({ success: false });
          });



          
        
       
      } 
    }
  
  }